import { Clock } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const HistoryIcon = DeckardIconWrapper({ Icon: Clock });
